class CartRecommendations extends HTMLElement {
  connectedCallback() {
    this.loaded = false;
    this.dialog = this.closest('dialog');
    if (this.dialog) {
      this.observer = new MutationObserver(() => {
        if (this.dialog.hasAttribute('open')) {
          this.fetchRecommendations();
        }
      });
      this.observer.observe(this.dialog, { attributes: true, attributeFilter: ['open'] });
      if (this.dialog.hasAttribute('open')) {
        this.fetchRecommendations();
      }
    } else {
      this.fetchRecommendations();
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  fetchRecommendations() {
    if (this.loaded) return;
    const productId = this.dataset.productId;
    const url = this.dataset.url;
    if (!productId || !url) return;
    const params = new URLSearchParams({
      section_id: 'cart-recommendations',
      product_id: productId,
      intent: 'related',
      limit: 4
    });
    fetch(`${url}?${params.toString()}`)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const content = doc.getElementById('cart-recommendations-content');
        if (content && content.innerHTML.trim()) {
          this.innerHTML = content.innerHTML;
          this.loaded = true;
        }
      })
      .catch(() => {});
  }
}

if (!customElements.get('cart-recommendations')) {
  customElements.define('cart-recommendations', CartRecommendations);
}